import { Component, EventEmitter, Input, Output } from "@angular/core";

import { Observable, Subject } from 'rxjs';

import { CommandRelay } from '../../../shared/commands/command-relay.class';

import { SignataireEntity } from "../entities/signataire.entity";

@Component({
	selector: 'signataire-dialog',
	templateUrl: 'signataires-dialog.html',
	styleUrls: ['signataires-dialog.css']
})
export class SignatairesDialogComponent {
	signatairesNonLies: SignataireEntity[] = [];
	signatairesLies: SignataireEntity[] = [];
	displaySubject = new Subject<boolean>();

	getIntervenantLabel = (intervenant: any) => (intervenant.prenom ? intervenant.prenom + ' ' : '')  + intervenant.nom;

	constructor() { }
	
	@Input() id: string = 'signatairesDialog';

	private initCommandsRelay = new CommandRelay<[SignataireEntity[], SignataireEntity[]]>(
		data => {
			this.display([ ... data[0] ], [ ... data[1] ]);
		}
	);
	@Input() set initCommands(obs: Observable<[SignataireEntity[], SignataireEntity[]]> | null | undefined) {
		this.initCommandsRelay.register(obs);
	}

	@Output() signatairesSelected = new EventEmitter<[SignataireEntity[], SignataireEntity[]]>();

	@Output() closed = new EventEmitter<void>();

	private display(signatairesNonLies: SignataireEntity[], signatairesLies: SignataireEntity[]) {
		this.signatairesNonLies = signatairesNonLies;
		this.signatairesLies = signatairesLies;
		this.displaySubject.next(true);
	}

	save() {
		this.signatairesSelected.emit([this.signatairesNonLies, this.signatairesLies]);
		this.displaySubject.next(false);
	}

	onCloseRequested() {
		this.signatairesNonLies = [];
		this.signatairesLies = [];
		this.displaySubject.next(false);
	}
	
	onClosed() {
		this.closed.emit();
	}
}